import { nextStepPage, nextStepTokenResponse } from '../../../config/Enum/NextStep';
import { StepPages } from '../../../proto/out/ir/uid/base/base';

export const getNextStepPage = ({ responseContext, navigate }) => {
  navigate(
    '/' +
      // @ts-ignore
      nextStepPage[
        // @ts-ignore
        StepPages[responseContext?.responseContext.nextStep[nextStepTokenResponse.GENERAL].nextStepPage]
      ],
  );
};
